module.exports = __webpack_public_path__ + "static/img/4.e84e5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/4.png
// module id = WS8i
// module chunks = 0